import { useState } from 'react';
import { DateRangePicker, rangeToBounds, type RangePreset } from '../components/DateRangePicker.js';
import { SpindleChart } from '../components/SpindleChart.js';
import { FeedRateChart } from '../components/FeedRateChart.js';
import { OEEChart } from '../components/OEEChart.js';
import { useMachineTelemetry } from '../hooks/useMachineTelemetry.js';

export interface TelemetryTabProps {
  readonly shopId: string | null;
  readonly machineId: string;
}

export function TelemetryTab({ shopId, machineId }: TelemetryTabProps): JSX.Element {
  const [preset, setPreset] = useState<RangePreset>('24h');
  const range = rangeToBounds(preset);
  const { points, isLoading } = useMachineTelemetry({ shopId, machineId, range });

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-xs text-text-dim">
          {points?.length ?? 0} samples
        </p>
        <DateRangePicker value={preset} onChange={setPreset} />
      </div>
      <SpindleChart points={points} loading={isLoading} />
      <FeedRateChart points={points} loading={isLoading} />
      <OEEChart points={points} loading={isLoading} />
    </div>
  );
}
